import { useState } from "react";

import { Booking } from "../../../../models/booking";
import { CartonView } from "../../../../models/carton";
import { PurchaseOrder } from "../../../../models/purchase.order";
import useAction from "./useAction";

interface UseSSCCProps {
  booking: Booking | undefined;
  cartons: CartonView[];
  purchaseOrder?: PurchaseOrder;
}

export const useSSCC = ({ booking, cartons, purchaseOrder }: UseSSCCProps) => {
  const [selectedId, setSelectedId] = useState<string>("");

  const { useGenerateCartonReport } = useAction();

  const { mutate: generateLabelReport, isLoading: generatingLabelReport } =
    useGenerateCartonReport();

  const handleGenerateLabelReport = (_cartons: CartonView[]) => {
    generateLabelReport({
      cartons: _cartons,
      booking,
      purchaseOrder,
      bookingCartonsTotal: cartons.length,
    });
  };

  const handlePrintLabel = (cartonSSCC?: string) => {
    let cartonIndex;
    const carton = cartons.find((carton, index) => {
      if (String(carton.sscc) === String(cartonSSCC)) {
        cartonIndex = index;

        return true;
      }

      return false;
    });

    setSelectedId(String(cartonSSCC));

    if (carton) handleGenerateLabelReport([{ lineId: cartonIndex, ...carton }]);
  };

  return {
    handlePrintLabel,
    handleGenerateLabelReport,
    selectedId,
    setSelectedId,
    generatingLabelReport,
  };
};
